import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import Divider from "@/components/common/Divider";
import styles from "./Credits.module.css";

export interface CreditsProps extends HTMLProps<HTMLDivElement> {}

export default function Credits({
	className
} : CreditsProps) {

	return (
		<div
			className={cn(
				styles.Credits,
				className
			)}
		>
			<span>Copyright {new Date().getFullYear()}</span>
			<Divider className={styles.CreditsDivider} />
			<span>Site by <a href="https://hyperobjekt.com" target="_blank">Hyperobjekt</a></span>
		</div>
	);
}